// Client-side PostHog loader. The key/host/DID are injected server-side as
// data-* attributes on this script tag (see src/pages/shell.ts) so the browser
// can initialise posthog-js and capture $pageview / autocapture events. The
// posthog-js library itself is loaded from PostHog's CDN by the snippet below.
;(function () {
  var el = document.currentScript
  if (!el) return
  var key = el.dataset.phKey
  // No project key configured (e.g. local dev without POSTHOG_API_KEY) — skip.
  if (!key) return
  var host = el.dataset.phHost || 'https://eu.i.posthog.com'
  var did = el.dataset.phDid || ''

  // Official PostHog snippet: defines a queuing stub on window.posthog and
  // asynchronously loads the full library (array.js) from the assets CDN.
  !(function (t, e) {
    var o, n, p, r
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split('.')
          2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
            })
        }
        ;(p = t.createElement('script')).type = 'text/javascript'
        p.crossOrigin = 'anonymous'
        p.async = !0
        p.src =
          s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') +
          '/static/array.js'
        ;(r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r)
        var u = e
        for (
          void 0 !== a ? (u = e[a] = []) : (a = 'posthog'),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = 'posthog'
              return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e
            },
            u.people.toString = function () {
              return u.toString(1) + '.people (stub)'
            },
            o =
              'init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug getPageViewId captureTraceFeedback captureTraceMetric'.split(
                ' ',
              ),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n])
        e._i.push([i, s, a])
      }),
      (e.__SV = 1))
  })(document, window.posthog || [])

  window.posthog.init(key, {
    api_host: host,
    // Only create person profiles for logged-in users; anonymous visits are
    // still counted as pageviews but don't spin up a profile each.
    person_profiles: 'identified_only',
  })

  // Link this browser session to the server-side distinct id (the pet/user
  // DID) so client pageviews and server-side events share one person.
  if (did) window.posthog.identify(did)
})()
